import { Paperclip } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { usePublicShareUploadedDocuments } from '../api/public-share-api';
import { formatIsoDate } from '../utils/format';
import { PublicSection } from './PublicSection';

function formatSize(bytes: number | null): string | null {
  if (bytes === null || bytes === undefined) return null;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function PublicUploadedDocumentsList({ token }: { token: string }) {
  const { data, isLoading } = usePublicShareUploadedDocuments(token, true);
  const rows = data?.data ?? [];
  return (
    <PublicSection
      title="Uploaded documents"
      icon={Paperclip}
      count={rows.length}
      isLoading={isLoading}
      emptyMessage="No uploaded documents to show."
    >
      <ul className="divide-y">
        {rows.map((d) => {
          const docDate = formatIsoDate(d.document_date);
          const size = formatSize(d.file_size);
          return (
            <li key={d.id} className="py-3">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-medium">{d.name}</span>
                {d.document_type && (
                  <Badge variant="secondary" className="text-xs">{d.document_type}</Badge>
                )}
              </div>
              <div className="mt-0.5 flex flex-wrap gap-x-3 gap-y-0.5 text-xs text-muted-foreground">
                {docDate && <span>{docDate}</span>}
                {d.filename && <span className="font-mono">{d.filename}</span>}
                {size && <span>{size}</span>}
                {d.content_type && <span>{d.content_type}</span>}
              </div>
              {d.notes && (
                <p className="mt-1 text-xs text-muted-foreground italic">{d.notes}</p>
              )}
            </li>
          );
        })}
      </ul>
    </PublicSection>
  );
}
